import { StyledMenu } from './styles';
import type { TMenuProps } from './types';

export const Menu = (props: TMenuProps) => {
  return <StyledMenu {...props} />;
};
